import React from 'react';
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import { ElementType, NumberFormat, SelectCombos, CommonResponses, } from '../Enums/constants';


export const PabsUkDeferredsTab = () => {
  return (
    <SurveyPage pageName='Deferreds'>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Pension Set Ups'>
          <SurveyElement
            questionNumber='19'
            labelText="What % of pensions were set-up (with the first instalment being paid) within 1 month from the date of the deferred member's requested retirement date?"
            note='If the deferred member asks for the pension to be backdated then the measure should be from the point the member asks for the pension to come into payment.'
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
            name='UKMDeferredSetUpRequested'
            allowUnknown
          />
          <SurveyElement
            questionNumber='20'
            labelText="What % of tax free lump sum payments were paid within 1 week of the deferred member's retirement date?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
            name='UKMDeferredLumpRequested'
            allowUnknown
          />
        </SurveySection>

        <SurveySection labelText='Tracing Members'>
          <SurveyElement
            questionNumber='21'
            labelText="What % of deferred members that reached their normal retirement age in the year have not received any benefits yet because mail has been returned and the member had been recorded as 'gone away'?"
            name='UKDeferredMailReturn'
            allowUnknown
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
        />
          <SurveyElement
            questionNumber='22'
            labelText="How many deferred members are past their normal retirement age and have not received any benefits yet?"
            name='UKDeferredPastNRA'
            allowUnknown
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder='#, unknown'
          />
          <SurveyElement
            questionNumber='23'
            labelText='What % of deferred members do you hold email addresses for?'
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
            name='UKDeferredHoldEmailPct'
            allowUnknown
          />
          <SurveyElement
            questionNumber='24'
            labelText='What % of deferred members do you hold home addresses for?'
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
            name='UKDeferredHoldHomePct'
            allowUnknown
          />
          <SurveyElement
            questionNumber='25'
            labelText="What percentage of 'Common Data' have you assessed to be present and accurate for deferred members only?"
            inputType={ElementType.NUMBER}
            format={NumberFormat.PERCENTAGE_UK}
            placeholder='%, unknown'
            name='UKDeferredCommonDataPct'
            allowUnknown
          />
        </SurveySection>

        <SurveySection labelText='Elapsed Times'>
          <p>
            We are asking for details of elapsed times, which reflect the
            members' actual service experience, measured from the point of the
            members' request, from the event triggering the transaction, or from
            the point you were first notified to the point of fulfilment. If you
            don't measure elapsed times then please feel free to estimate, i.e.,
            a typical transfer out might take 3 months from the point of
            acceptance.
          </p>
        </SurveySection>

        <SurveySection labelText='Transfers Out'>
          <SurveyElement
            questionNumber='26'
            labelText='Do you offer transfer out?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKDeferredElapsedTimesTransfersOutYN'
          />
          <SurveyConditionalSegment
            showIf={{
              UKDeferredElapsedTimesTransfersOutYN: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='26.a'
              labelText='Quote: What is the average elapsed time from the point of the initial request to the point a quotation is issued (in days, including delays caused by third parties)?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='# days, unknown, n/a'
              name='UKDeferredElapsedTimesTransfersOutQuote'
              allowUnknown
              allowNA
            />
            <SurveyElement
              questionNumber='26.b'
              labelText='Is this measured or estimated?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.MEASURED_ESTIMATED_NA}
              name='UKDeferredElapsedTimesTransfersOutQuoteMeasure'
            />
            <SurveyElement
              questionNumber='27'
              labelText='Completion: What is the average elapsed time from the point of acceptance of the quotation to the point of the physical transfer (in weeks, including delays caused by third-parties)?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='# weeks, unknown, n/a'
              name='UKDeferredElapsedTimesTransfersOutCompletion'
              allowUnknown
              allowNA
            />
            <SurveyElement
              questionNumber='27.a'
              labelText='Is this measured or estimated?'
              inputType={ElementType.RADIOBUTTON}
              options={SelectCombos.MEASURED_ESTIMATED_NA}
              name='UKDeferredElapsedTimesTransfersOutCompletionMeasure'
            />
          </SurveyConditionalSegment>
        </SurveySection>

        <SurveySection labelText='Death-in-Deferment'>
          <SurveyElement
            questionNumber='28'
            labelText='What is the average elapsed time from the point of initial notification to the point of paying the first instalment of any dependent’s pension and/or paying the lump sum, whichever is later (in weeks, including delays caused by third-parties)?'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder='# weeks, unknown'
            name='UKDeferredElapsedTimesDeathInDeferment'
            allowUnknown
          />
          <SurveyElement
            questionNumber='28.a'
            labelText='Is this measured or estimated?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.MEASURED_ESTIMATED}
            name='UKDeferredElapsedTimesDeathInDefermentMeasure'
          />
        </SurveySection>

        <SurveySection labelText='Benefit Statements / Estimates / Calculators'>
          <SurveyElement
            questionNumber='29'
            labelText="Which of the following describes how you help deferred members to understand the pension they can expect at retirement?  (You can say 'yes' to more than one choice)."
            name=''
          />
          <SurveyElement
            questionNumber='29.a'
            labelText='Send (physical, hard copy) benefit statements to all deferred members as a matter our course every year?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKMv_193c'
            subQuestion
          />
          <SurveyElement
            questionNumber='29.b'
            labelText='Direct members to an annual benefit statement, or the data that would be found in a benefit statement, posted in the secure area of your website for all deferred members as a matter our course every year?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKDeferredBenefitStatementsDirectAnnualStatement'
            subQuestion
          />
          <SurveyElement
            questionNumber='29.c'
            labelText='Direct deferred members towards the calculator on your website (where the calculator is linked to member data)?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='UKDeferredBenefitStatementsDirectCalculatorLinked'
            subQuestion
          />
          <SurveyElement
            questionNumber='29.d'
            labelText='Provide a hard copy estimate in the post on request.'
            name='UKEstimatesDeferredOnDemand'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            pageName='Actives'
            subQuestion
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}